"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.counter = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const tsdb_1 = require("../tsdb");
const VariableName_1 = require("../VariableName");
exports.counter = {
    __basic_data_type: true,
    __variable_name_data_type: true,
    __tsdb_data_type: true,
    id: 'counter',
    title: 'People count',
    variableName: VariableName_1.VariableName.counter,
    dbTable: tsdb_1.TSDBTable.counter,
    icon: free_solid_svg_icons_1.faUser,
    isSlotted: false,
    order: 10,
    colormap: [
        { value: 0, rgb: [98, 170, 16, 1] },
        { value: 0.45, rgb: [220, 190, 25, 1] },
        { value: 0.55, rgb: [220, 190, 25, 1] },
        { value: 1, rgb: [231, 59, 75, 1] },
    ],
    dataPointConverter: x => x,
    unit: '',
    decimals: 1,
};
//# sourceMappingURL=counter.js.map